export default __webpack_public_path__ + "static/media/logo.e2f14e5b.png";